
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent-resources/register-confirmation",
      function () {
        return require("private-next-pages/agent-resources/register-confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent-resources/register-confirmation"])
      });
    }
  